exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-more[data-v-200a7400] {\n  margin-top: 7px;\n  text-align: right;\n}\n.view-more[data-v-200a7400]:hover {\n  font-weight: bold;\n}\n.link[data-v-200a7400] {\n  color: #67C23A !important;\n}\n.accordion .cof-customer-box[data-v-200a7400] {\n  position: relative;\n  height: 51px;\n  overflow: hidden;\n  padding: 0 16px;\n  margin: 15px 30px;\n  background: #f8f9fb;\n  border-radius: 16px;\n}\n.accordion .cof-box-active[data-v-200a7400] {\n  height: auto;\n}\n.card-number[data-v-200a7400], .card-exp-m[data-v-200a7400], .card-cvv[data-v-200a7400], .cardholder[data-v-200a7400] {\n  font-weight: bold;\n  font-size: 18px;\n}", ""]);

// exports
